import SettingsIcon from "@material-ui/icons/Settings";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import EqualizerIcon from "@material-ui/icons/Equalizer";
import PermDataSettingIcon from "@material-ui/icons/PermDataSetting";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
//import Login from "views/Login/login.js";
import ListAltOutlinedIcon from "@material-ui/icons/ListAltOutlined";
import Comparation from "views/Inicio/index";
//import Sdaca from "views/Scada/index";
import Requisiones from "./views/Inicio/componentes/requisiones";
import Ordenes from "./views/Inicio/componentes/ordenes";
import Rendisiones from "./views/Inicio/componentes/rendiciones";
import Servicio from "./views/Inicio/componentes/servicios";
import Proveedores from "./views/Inicio/componentes/proveedores";
//import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
import HomeIcon from "@material-ui/icons/Home";
import Configuraciones from "views/Inicio/componentes/configuraciones";
const dashboardRoutes = [
  {
    path: "/inicio",
    name: "Inicio",

    icon: HomeIcon,
    component: Comparation,
    layout: "/admin",
  },
  {
    path: "/Requisiciones",
    name: "Requisiciones",

    icon: EqualizerIcon,
    component: Requisiones,
    layout: "/admin",
  },
  {
    path: "/ordenes",
    name: "Ordenes de Compra",

    icon: ListAltOutlinedIcon,
    component: Ordenes,
    layout: "/admin",
  },
  {
    path: "/rendiciones",
    name: "Rendiciones",

    icon: TrendingUpIcon,
    component: Rendisiones,
    layout: "/admin",
  },
  {
    path: "/servicios",
    name: "Servicios ",

    icon: PermDataSettingIcon,
    component: Servicio,
    layout: "/admin",
  },
  {
    path: "/proveedores",
    name: "Proveedores",

    icon: SupervisorAccountIcon,
    component: Proveedores,
    layout: "/admin",
  },
  {
    path: "/configuracion",
    name: "Configuración",

    icon: SettingsIcon,
    // component: "",
    component: Configuraciones,
    layout: "/admin",
  },
];

export default dashboardRoutes;
